import React from 'react';
import Localize from 'react-intl-universal';

import { Formik, Form } from 'formik';

import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import CreateFieldsFromConfig from '@components/CreateFormFields/CreateFieldsFromConfig';

import { signUpConfig } from './config';
import initialValues from './initialValues';
import useCreateSchema from './useCreateSchema';

const StyledLoadingButton = styled(LoadingButton)(({ theme }) => ({
  fontWeight: '700',
  width: '45%',
  fontSize: '14px',
  textTransform: 'none',
  borderRadius: '1',
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  '&.MuiLoadingButton-loading': {
    width: '12rem'
  },
  '&.Mui-disabled': {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.common.white
  },
  '&:hover': {
    backgroundColor: theme.palette.primary.light
  }
}));

const SignUpForm = () => {
  const validationSchema = useCreateSchema();

  const handleSignUp = () => {};

  const onSubmit = async (values, { setSubmitting }) => {
    setSubmitting(false);
  };

  return (
    <Formik
      validateOnMount
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {({ isValid }) => (
        <>
          <Typography variant='h6' gutterBottom>
            {Localize.get('SignIn.personalAccount')}
          </Typography>
          <Form>
            <Grid container columnSpacing={{ xs: 4 }}>
              <CreateFieldsFromConfig config={signUpConfig} />
            </Grid>
          </Form>

          <Box sx={{ display: 'flex', justifyContent: 'center', padding: '0', mt: 6 }}>
            <StyledLoadingButton onClick={handleSignUp} disabled={!isValid}>
              {Localize.get('SignIn.submit')}
            </StyledLoadingButton>
          </Box>
        </>
      )}
    </Formik>
  );
};

export default SignUpForm;
